import { Link } from "react-router-dom";
import { Instagram, Phone, MessageCircle, Mail, MapPin, ArrowUpRight, Code2 } from "lucide-react";
import { NAV, CONTACT, EKTIREN, waLink } from "@/data/site";
import logo from "@/assets/brand/logo.jpg";
import ektirenLogo from "@/assets/brand/ektiren-logo.png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-ink-900 overflow-hidden">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-neon-purple/20 blur-[140px] rounded-full pointer-events-none" />

      {/* Ektiren Project dedicated section */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-16">
        <div data-testid="ektiren-project-section" className="neon-border rounded-3xl glass p-6 sm:p-10 flex flex-col md:flex-row items-center gap-8">
          <img src={ektirenLogo} alt="Ektiren Project" className="h-16 w-auto object-contain" />
          <div className="flex-1 text-center md:text-left">
            <p className="font-mono text-xs uppercase tracking-widest text-cobalt-300">Bu site kim tarafından yapıldı?</p>
            <h3 className="font-display text-2xl sm:text-3xl font-extrabold mt-2">
              Tasarım &amp; Geliştirme: <span className="text-gradient">{EKTIREN.name}</span>
            </h3>
            <p className="text-slate-400 mt-2 max-w-xl">{EKTIREN.tagline}. Markanız için modern, hızlı ve dönüşüm odaklı web siteleri.</p>
          </div>
          <div className="flex flex-col gap-3 w-full md:w-auto">
            <a
              href={waLink(EKTIREN.phoneRaw, "Merhaba Ektiren Project, web sitesi yaptırmak istiyorum.")}
              target="_blank" rel="noreferrer"
              data-testid="ektiren-whatsapp-button"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-cobalt to-neon-purple text-white font-semibold hover:scale-[1.03] transition-transform"
            >
              <MessageCircle className="w-4 h-4" /> {EKTIREN.phone}
            </a>
            <span className="text-center text-xs text-slate-500 font-mono">Powered by Ektiren Project</span>
          </div>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-3">
            <img src={logo} alt="İzmir Medya" className="h-12 w-12 rounded-full ring-1 ring-white/20" />
            <span className="font-display font-extrabold text-xl">İzmir<span className="text-gradient inline-block pr-[0.12em] ml-[0.28em]">Medya</span></span>
          </Link>
          <p className="text-slate-400 mt-4 max-w-sm text-sm leading-relaxed">
            Sosyal Medya Yönetimi · Prodüksiyon · Dijital Çözümler. Ege'nin dijital nabzı, markanızın büyüme motoru.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={CONTACT.instagramUrl} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="p-3 rounded-full bg-white/5 border border-white/10 hover:bg-neon-magenta/20 hover:border-neon-magenta transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={waLink(CONTACT.phoneRaw, "Merhaba, bilgi almak istiyorum.")} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="p-3 rounded-full bg-white/5 border border-white/10 hover:bg-green-500/20 hover:border-green-500 transition-colors">
              <MessageCircle className="w-5 h-5" />
            </a>
            <a href={`tel:${CONTACT.phoneRaw}`} data-testid="footer-phone" className="p-3 rounded-full bg-white/5 border border-white/10 hover:bg-cobalt/20 hover:border-cobalt transition-colors">
              <Phone className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display font-bold mb-4">Sayfalar</h4>
          <ul className="space-y-2">
            {NAV.map((n) => (
              <li key={n.path}>
                <Link to={n.path} className="text-slate-400 hover:text-white text-sm inline-flex items-center gap-1 group">
                  {n.label}<ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold mb-4">İletişim</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-neon-magenta" /> {CONTACT.phone}</li>
            <li className="flex items-center gap-2"><Instagram className="w-4 h-4 text-neon-magenta" /> {CONTACT.instagram}</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-neon-magenta" /> {CONTACT.email}</li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-neon-magenta" /> {CONTACT.city}</li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} İzmir Medya — izmir35medya.com · Tüm hakları saklıdır.</span>
          <a href={waLink(EKTIREN.phoneRaw, "Merhaba Ektiren Project")} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 font-mono text-cobalt-300 hover:text-neon-magenta transition-colors">
            <Code2 className="w-3.5 h-3.5" /> Bir <span className="font-bold text-white">Ektiren Project</span> işidir
          </a>
        </div>
      </div>
    </footer>
  );
}
